import type { FaireProductEntity } from "../../entity_types/product";

export const p_vzbey9d7b2: FaireProductEntity = {
  token: "p_vzbey9d7b2",
  type: "product",
  name: "Happy Mahalo - Thank You Card",
  brandName: "Design Jord",
  imageUrl:
    "https://cdn.faire.com/fastly/72a275148cc05ad8619028de272238ad854018d9054bdec8a74d336d983971a7.jpeg",
  priceDollars: 2.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/978570c0dfdaf8951f91dae6e05292197d7f5beb166343971e9e53fe38749918.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
